export const communitySortKeys = {
  newest: 'newest',
  oldest: 'oldest',
  rated: 'rated',
};
